module.exports = __webpack_public_path__ + "img/caret-up-square.09b9b58e.svg";